<div class="sidenav-container">
  <div class="main-menu">
    @if (hasVehicles || subscription.isFree) {
      <!-- Default Navigation -->
      @for (item of navigationPages; track item) {
        <ng-container
          *ngTemplateOutlet="pageButtonTml; context: { page: item }"
        ></ng-container>
      }
    }
    @else {
      <!-- Get Started Navigation -->
      @for (item of getStartedPages; track item) {
        <ng-container
          *ngTemplateOutlet="pageButtonTml; context: { page: item }"
        ></ng-container>
      }
    }
  </div>

  <div class="extras" *ngIf="sidenav.extraMenu">
    <mat-divider></mat-divider>
    <ng-container *ngTemplateOutlet="sidenav.extraMenu"></ng-container>
  </div>

  <div class="smaller-links mat-caption">
    @for (item of externalLinks; track item) {
      @if (item.externalLink) {
        <!-- External Website Link -->
        <a [href]="item.link" target="_blank">
          <ng-container *ngTemplateOutlet="linkDisplay; context: { item }" />
        </a>
      } @else if (item.link) {
        <!-- Internal Link -->
        <a
          [routerLink]="item.link"
          [trackElement]="item.name"
          [trackEvents]="['click', 'mouseenter', 'mouseleave']"
        >
          <ng-container *ngTemplateOutlet="linkDisplay; context: { item }" />
        </a>
      } @else if (item.action) {
        <!-- Dialog -->
        <a
          (click)="onSmallerItemClick(item.action)"
          [trackElement]="item.name"
          [trackEvents]="['click', 'mouseenter', 'mouseleave']"
        >
          <ng-container *ngTemplateOutlet="linkDisplay; context: { item }" />
        </a>
        }
      }
  </div>
</div>

<ng-template #pageButtonTml let-page="page">
  @if (
    page.visible !== false &&
    (!page.onlyForInstance || (page.onlyForInstance | includes : subscription.type)) &&
    ((page.name !== 'Account' && page.name !== 'Fleet' && page.name !== 'Subscription') ||
      (page.permissionsRequired | hasPermissions | async))
  ) {
    <!-- Direct Link -->
    @if (page.subPages === undefined) {
      @if (page.disabled || (page.permissionsRequired && !(page.permissionsRequired | hasPermissions | async))) {
        <ng-container *ngTemplateOutlet="buttonTml; context: { page, disabled: true }"></ng-container>
      }
      @else {
        <a [routerLink]="page.link" queryParamsHandling="preserve">
          <ng-container *ngTemplateOutlet="buttonTml; context: { page, disabled: false }"></ng-container>
        </a>
      }
    }
    @else {
      <div (click)="toggleSubMenu(page)">
        <ng-container *ngTemplateOutlet="buttonTml; context: { page }"></ng-container>
      </div>
      <div
        class="sub-menu"
        [ngStyle]="{ 'maxHeight.px': 48 * page.subPages.length }"
        [ngClass]="{ closed: !(activeSubMenus | has : page.name) }"
      >
        @for (subPage of page.subPages; track subPage) {
          @if (subPage.disabled || (page.permissionsRequired && !(subPage.permissionsRequired | hasPermissions | async))) {
            <ng-container *ngTemplateOutlet="buttonTml; context: { page: subPage, disabled: true }"></ng-container>
          }
          @else {
            <a
              [routerLink]="subPage.link"
              queryParamsHandling="preserve"
            >
              <ng-container *ngTemplateOutlet="buttonTml; context: { page: subPage, disabled: false }"></ng-container>
            </a>
          }
        }
      </div>
    }
  }
</ng-template>

<ng-template #buttonTml let-page="page" let-disabled="disabled">
  @if (
    page.visible !== false &&
    (!page.onlyForInstance || (page.onlyForInstance | includes : subscription.type))
  ) {
    <button
      mat-button
      class="link-button"
      [ngClass]="{
        active:
          (page.subPages === undefined && page | isActive | async) ||
          (page.subPages !== undefined && !(activeSubMenus | has : page.name) && page | isActive | async)
      }"
      [disabled]="disabled"
    >
      <mat-icon
        *ngIf="page.icon !== undefined"
        class="material-icons-rounded"
        [svgIcon]="page.svgIcon ? page.icon : undefined"
      >
        {{ page.svgIcon ? '' : page.icon }}
      </mat-icon>

      <span class="menu-link-title">
        <span>{{ 'pages.' + page.name | transloco }}</span>
        @if (page.subPages !== undefined) {
          <mat-icon
            class="material-icons-rounded chevron"
            [ngClass]="{ open: activeSubMenus | has : page.name }"
          >
            expand_more
          </mat-icon>
        }

        @if (disabled) {
          <mat-icon
            class="material-icons-outlined lock"
            [ngClass]="{ open: activeSubMenus | has : page.name }"
          >
            lock
          </mat-icon>
        }
      </span>
    </button>
  }
</ng-template>

<ng-template #linkDisplay let-item="item">
  <mat-icon *ngIf="item.icon" [svgIcon]="item.svgIcon ? item.icon : ''">
    {{ item.icon }}
  </mat-icon>
  <span>{{
    item.name === 'zevaglobal.com' ? item.name : ('pages.' + item.name | transloco)
  }}</span>
</ng-template>
